import { Divider } from '@faceup/ui-base'
import { defaultLogoSize } from '@faceup/utils'
import { type FragmentType, getFragmentData, graphql } from '../../__generated__'
import { useClient } from '../../App/ClientProvider'
import { Header } from '../Header/Header'
import { SimpleHeaderContent } from '../Header/SimpleHeaderContent'
import InstitutionLogo from '../InstitutionLogo'

const fragments = {
  SurveyHeader_survey: graphql(`
    fragment SurveyHeader_survey on PublicSurvey {
      id
      logoUrl
      defaultLanguage
      institution {
        id
        config {
          id
          institutionName
        }
        partner {
          id
          name
          config {
            id
            rectangularLogoUrl
          }
        }
      }
    }
  `),
}

type SurveyHeaderProps = {
  survey: FragmentType<typeof fragments.SurveyHeader_survey>
  isHiddenBackButton?: boolean
}

export const SurveyHeader = ({ survey: _survey, isHiddenBackButton }: SurveyHeaderProps) => {
  const survey = getFragmentData(fragments.SurveyHeader_survey, _survey)
  const { client } = useClient()
  const isApp = client === 'app'

  return (
    <Header>
      <SimpleHeaderContent
        isApp={isApp}
        isHiddenBackButton={isHiddenBackButton ?? false}
        // Surveys are a single-page branch; the homepage is the survey route itself.
        homepageLinkCallback={routes => routes.survey()}
        logoSlot={
          <div className='flex gap-4 nowrap max-h-full items-center overflow-hidden min-w-0'>
            <InstitutionLogo
              name={survey.institution.config?.institutionName ?? ''}
              logoUrl={survey.logoUrl}
              logoSize={defaultLogoSize}
            />
            {survey.institution.partner?.config?.rectangularLogoUrl && (
              <>
                <Divider type='vertical' />
                <InstitutionLogo
                  name={survey.institution.partner.name}
                  logoUrl={survey.institution.partner.config.rectangularLogoUrl}
                  logoSize={defaultLogoSize}
                />
              </>
            )}
          </div>
        }
        languages={null}
        defaultLanguage={survey.defaultLanguage}
      />
    </Header>
  )
}
